import { TwistGeneratorOptionsType } from './types';

export const TWIST_GENERATOR_OPTIONS: TwistGeneratorOptionsType = [
  {
    id: 'already_in_relationship',
    title: "He/she/They're already in a relationship",
  },
  {
    id: 'its_your_ex',
    title: "It's your ex",
  },
  {
    id: 'someone_famous',
    title: "It's someone famous",
  },
  {
    id: 'disappear_morning',
    title: 'They disappear in the morning without a trace',
  },
  {
    id: 'wake_up_another_city',
    title: 'You wake up in another city',
  },
  {
    id: 'skip',
    title: 'Skip',
  },
];
